import React from "react";

function MinusCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76536 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51774 9.51009 10.0534 8.7084C10.5891 7.90671 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM7.875 6.375H4.125C4.02555 6.375 3.93016 6.33549 3.85984 6.26517C3.78951 6.19484 3.75 6.09946 3.75 6C3.75 5.90054 3.78951 5.80516 3.85984 5.73484C3.93016 5.66451 4.02555 5.625 4.125 5.625H7.875C7.97446 5.625 8.06984 5.66451 8.14017 5.73484C8.21049 5.80516 8.25 5.90054 8.25 6C8.25 6.09946 8.21049 6.19484 8.14017 6.26517C8.06984 6.33549 7.97446 6.375 7.875 6.375Z"
        fill="#E03B24"
      />
    </svg>
  );
}

export default MinusCircle;
